import React from "react"
import { css } from "@emotion/core"

export default function MaxWidthContainer({ children }) {
  return (
    <div css={css`
      width: 100%;
      max-width: 1100px;
      margin-left: auto;
      margin-right: auto;
      padding-left: 32px;
      padding-right: 32px;
      padding-top: 32px;
    `}>
      {children}
    </div>
  )
}

// TODO: Support media query
 